/**
 * Combines all auto-send effects: template fill, URL prompt injection, and deep-link template loading.
 */

import type { UseChatDeepLinkReturn } from './use-chat-deep-link.hook'
import { useChatDeepLink } from './use-chat-deep-link.hook'
import type { UseChatInputReturn } from './use-chat-input.hook'
import type { UseChatMessagesReturn } from './use-chat-messages.hook'
import { useChatPromptInjection } from './use-chat-prompt-injection.hook'
import type { UseChatSendHandlerReturn } from './use-chat-send-handler.hook'
import { useTemplateAutoSend } from './use-template-auto-send.hook'

interface UseChatAutoSendEffectsParams {
  input: UseChatInputReturn
  messages: UseChatMessagesReturn
  sendHandler: UseChatSendHandlerReturn
  agencySlug?: string
}

export const useChatAutoSendEffects = ({
  input,
  messages,
  sendHandler,
  agencySlug,
}: UseChatAutoSendEffectsParams): UseChatDeepLinkReturn => {
  useTemplateAutoSend({
    isPendingSend: input.pendingTemplateSend,
    clearPendingSend: input.clearPendingTemplateSend,
    onSend: sendHandler.handleSend,
  })
  useChatPromptInjection({
    sendMessage: messages.sendMessage,
  })
  return useChatDeepLink({
    agencySlug,
    setInputValue: input.setInputValue,
    triggerPendingTemplateSend: input.triggerPendingTemplateSend,
  })
}
